export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        <div className="text-6xl mb-4">404</div>
        <h1 className="text-3xl font-bold text-white mb-4">Not Found</h1>
        <p className="text-gray-400 max-w-md">
          This review link is invalid. Please check the URL or contact the
          producer for a new link.
        </p>
      </div>
    </div>
  );
}
